import Component from 'flarum/common/Component';
import Tooltip from 'flarum/common/components/Tooltip';
import app from 'flarum/forum/app';

class TicketStatusTag extends Component {
  view() {
    const status = getTicketStatus(this.attrs.ticket);

    // Return component
    return (
      <Tooltip
        text={app.translator.trans(`v17development-flarum-support.forum.tickets.status.${status}.description`)}
        position={this.attrs.tooltipPosition ? this.attrs.tooltipPosition : 'top'}
      >
        <div className={`Flarum-Support-status Flarum-Support-status--${status}`}>
          {app.translator.trans(`v17development-flarum-support.forum.tickets.status.${status}.title`)}
        </div>
      </Tooltip>
    );
  }
}

// Get status
function getTicketStatus(ticket) {
  return getStatusByNumber(ticket.ticketStatus(), ticket.answeredAt() !== null);
}

function getStatusByNumber(number, isSolved = false) {
  let status = 'open';

  if (number === 0) {
    status = 'new';
  } else if (number === 2) {
    status = 'pending';
  } else if (number === 3 && isSolved) {
    status = 'solved';
  } else if (number === 3) {
    status = 'closed';
  } else if (number === 4) {
    status = 'on_hold';
  } else if (number === 5) {
    status = 'duplicate';
  }

  return status;
}

export { TicketStatusTag, getTicketStatus, getStatusByNumber };
